import { makeRequest, CommonRequestOptions } from '../makeRequest';

export type CopyMediaOptions = CommonRequestOptions & {
   imageId?: number;
   id?: number;
   type?: 'image' | 'video';
};

export function copyMedia({ imageId, id, type, ...common }: CopyMediaOptions) {
   return makeRequest('post', 'user/media/copies', {
      body: {
         imageId,
         id,
         type,
      },
      ...common,
   });
}
